require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-msa-featured-by-verity.json") })
        }
      }, "path---blog-msa-featured-by-verity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-msa-featured-by-verity!./.cache/json/blog-msa-featured-by-verity.json
// module id = 381
// module chunks = 231608221292675